import "@styles/components/pill-list.css";

const observedElements = new Set();

const animatePillMarker = (pillList) => {
  pillList.querySelectorAll('[aria-selected="true"]').forEach((tab) => {
    const marker = tab.closest("[data-pill-list]").querySelector(".marker");
    marker.style.left = `${tab.offsetLeft}px`;
    marker.style.width = `${tab.offsetWidth}px`;
  });

  pillList.querySelectorAll("input:checked + [data-pill]").forEach((tab) => {
    const marker = tab.closest("[data-pill-list]").querySelector(".marker");
    marker.style.left = `${tab.offsetLeft}px`;
    marker.style.width = `${tab.offsetWidth}px`;
  });
};

export default {
  init: (pillList) => {
    const resizeAnimate = () => {
      animatePillMarker(pillList);
    };

    window.removeEventListener("resize", resizeAnimate);
    window.addEventListener("resize", resizeAnimate);

    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes" && mutation.attributeName === "aria-selected") {
          animatePillMarker(pillList);
        }
      }
    });

    pillList.querySelectorAll("[data-pill]").forEach((el) => {
      if (!observedElements.has(el)) {
        observer.observe(el, { attributes: true });
        observedElements.add(el);
      }
    });

    setTimeout(() => {
      animatePillMarker(pillList);
    }, 10);
  },
  animatePillMarker,
};
